module.exports = __webpack_public_path__ + "static/media/audition.c73dea40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/audition.png
// module id = 2544
// module chunks = 0